import { render, staticRenderFns } from "./ImgOrder.vue?vue&type=template&id=1275e5e4"
import script from "./ImgOrder.vue?vue&type=script&lang=js"
export * from "./ImgOrder.vue?vue&type=script&lang=js"
import style0 from "./ImgOrder.vue?vue&type=style&index=0&id=1275e5e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports